import React from "react";

export default function PageTitle({ title, subtitle=""  }) {
  return (
    <div className="flex flex-col">
      <span className="text-[18px] font-semibold font-sans text-slate-700 dark:text-slate-200 tracking-wider">
        {title}
      </span>
      {subtitle.trim()!=='' && (<>
      <span className="text-[12px] font-normal font-sans text-slate-700 dark:text-slate-200 ">
        {subtitle}
      </span>
      </>)}
    </div>
  );
}
